<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}">
</ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <!--breadcrumb-->
            <div class="page-breadcrumb d-sm-flex align-items-center mb-4">
                <div class="d-inline-block">
                    <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl =='/country'">Country</div>
                    <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl =='/city'">City</div>
                </div>

                <div class="ps-3 d-inline-block">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0)" routerLink="/dashboard"><i class="bx bx-home-alt"></i></a>
                            </li>
                            <li class="breadcrumb-item" *ngIf="CurrentUrl =='/city'"><a href="javascript:void(0)" routerLink="/country" >Country</a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl =='/country'">Country</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl =='/city'">City</li>
                        </ol>
                    </nav>
                </div>

                <div class="ms-auto pt-3 pt-sm-0">
                 
                    <div class="btn-group ms-2" role="group" *ngIf="CurrentUrl =='/city' && dataListing.length ==0">
                        <a href="javascript:void(0)" class="btn brand-border-btn" routerLink="/add-city">
                            Add City
                        </a>
                    </div>
                </div>
            </div>
            <!--end breadcrumb-->

            <div class="row align-items-end">
                <div class="col-12">
                    <div class="card" *ngIf="CurrentUrl =='/country'">
                        <div class="card-body  table-responsive">
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">No.</th>
                                        <th scope="col">Country Name </th>
                                        <th scope="col">Country Phone Code</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="dataListing.length !=0">
                                    <tr *ngFor="let item of dataListing ; let i = index ">
                                        <td scope="row">{{ i + 1 }}</td>
                                        <td>{{item.name}}</td>
                                        <td>+{{item.phoneCode}}</td>
                                        <td>
                                            <div class="btn-box">
                                                <button type="button" title="View" class="btn btn-primary text-center" (click)="redirect(item._id)">
                                                    View City 
                                                </button>
                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                                <tbody *ngIf="dataListing.length ==0">
                                    <tr>
                                        <p class="text-center">Sorry, No Record Found</p>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail((p = $event))" class="text-center" *ngIf="dataListing.length > 0"></pagination-controls>
                            </div> -->
                        </div>
                    </div>
               
                    <div class="card" *ngIf="CurrentUrl =='/city'">
                        <div class="card-body  table-responsive">
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">No.</th>
                                        <th scope="col">City Name </th>
                                      
                                    </tr>
                                </thead>
                                <tbody *ngIf="dataListing.length !=0">
                                    <tr *ngFor="let item of dataListing ; let i = index ">
                                        <td scope="row">{{ i + 1 }}</td>
                                        <td>{{item.name}}</td>
                                    </tr>

                                </tbody>
                                <tbody *ngIf="dataListing.length ==0">
                                    <tr>
                                        <p class="text-center">Sorry, No Record Found</p>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail((p = $event))" class="text-center" *ngIf="dataListing.length > 0"></pagination-controls>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <!--end row-->





        </div>
    </div>
    <app-footer></app-footer>
</div>
